import React from "react";
// Style components
import { Row, Image } from "antd";
// Images
import EscudoAlcaldiaBlanco from "./../../assets/logo_mobile_header.png";
import GOVCO from "./../../assets/landing/Logo.png";
import Logo2 from "./../../assets/landing/logo2.png";
// styles
import "./Footer.scss";

interface IProps {
  className?: string;
}

export const Footer: React.FC<IProps> = (props: IProps) => {
  return (
    <Row className={`container-footer ${props.className ? props.className : ""}`}>
      <div className="container-fluid2 mt-auto">
        <div className="row d-flex flex-row justify-content-between align-content-center align-items-center">
          {/* Columna izquierda (Información y Logo) */}
          <div className="col-12 col-md-6 pt-2 pb-2 d-flex flex-column justify-content-start align-content-center align-items-center">
            {/* Información antes de los logos */}
            <div className="footer-info mb-2" style={{color: 'whitesmoke'}}>
              <p><strong>Sede Principal:</strong> Alcaldía de Medellín</p>
              <p><strong>Dirección:</strong> Carrera 53 # 42 - 161</p>
              <p>Plaza de la Libertad. Piso 13. Torre A</p>
              <p><strong>Horario de atención:</strong> Lunes a viernes 8:00 a. m. a 5:00 p. m.</p>
              <p><strong>Líneas de atención:</strong></p>
              <p><strong>Correo convocatorias:</strong> <a href="mailto:convocatorias.cultura@medellin.gov.co" style={{color: 'whitesmoke'}}>convocatorias.cultura@medellin.gov.co</a></p>
              <p><strong>Correo para mentorías:</strong> <a href="mailto:mentoriascultura@medellin.gov.co" style={{color: 'whitesmoke'}}>mentoriascultura@medellin.gov.co</a></p>
            </div>
            {/* Logo de Alcaldía */}
            <br />
            <div className="d-flex justify-content-center pe-3">
              <Image src={EscudoAlcaldiaBlanco} className="img-fluid" preview={false} style={{ maxHeight: "70px" }} />
            </div>
          </div>
          {/* Columna derecha (Logos de Colombia y GOV.CO) */}
          <div className="col-12 col-md-6 d-flex justify-content-md-center pt-2 pb-2 align-content-center align-items-center">
            <div className="d-flex justify-content-center font-size-14px font-family-Montserrat-Regular">
              <div className="d-flex">
                <a href="https://www.colombia.co/">
                  <Image src={Logo2} className="img-fluid" preview={false} style={{ maxHeight: "30px" }} />
                </a>
              </div>
              <div className="d-flex ps-3 pe-3">
                <a href="https://www.gov.co">
                  <Image src={GOVCO} className="img-fluid" preview={false} style={{ maxHeight: "30px" }} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Row>
  );
};
